/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: pB3fVf-A_mDL

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicNewsItem.module.css"; // plasmic-import: pB3fVf-A_mDL/css

createPlasmicElementProxy;

export type PlasmicNewsItem__VariantMembers = {};
export type PlasmicNewsItem__VariantsArgs = {};
type VariantPropType = keyof PlasmicNewsItem__VariantsArgs;
export const PlasmicNewsItem__VariantProps = new Array<VariantPropType>();

export type PlasmicNewsItem__ArgsType = {
  description?: string;
  date?: string;
  title?: string;
  downloadUrl?: string;
};
type ArgPropType = keyof PlasmicNewsItem__ArgsType;
export const PlasmicNewsItem__ArgProps = new Array<ArgPropType>(
  "description",
  "date",
  "title",
  "downloadUrl"
);

export type PlasmicNewsItem__OverridesType = {
  newsExcerptsItem?: Flex__<"div">;
  top?: Flex__<"div">;
  excerptDate?: Flex__<"p">;
  title2?: Flex__<"h3">;
  desc?: Flex__<"p">;
  links?: Flex__<"div">;
  download?: Flex__<"a"> & Partial<LinkProps>;
};

export interface DefaultNewsItemProps {
  description?: string;
  date?: string;
  title?: string;
  downloadUrl?: string;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicNewsItem__RenderFunc(props: {
  variants: PlasmicNewsItem__VariantsArgs;
  args: PlasmicNewsItem__ArgsType;
  overrides: PlasmicNewsItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"newsExcerptsItem"}
      data-plasmic-override={overrides.newsExcerptsItem}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.newsExcerptsItem
      )}
    >
      <div
        data-plasmic-name={"top"}
        data-plasmic-override={overrides.top}
        className={classNames(projectcss.all, sty.top)}
      >
        <p
          data-plasmic-name={"excerptDate"}
          data-plasmic-override={overrides.excerptDate}
          className={classNames(
            projectcss.all,
            projectcss.p,
            projectcss.__wab_text,
            sty.excerptDate
          )}
        >
          <React.Fragment>{$props.date}</React.Fragment>
        </p>
        <h3
          data-plasmic-name={"title2"}
          data-plasmic-override={overrides.title2}
          className={classNames(
            projectcss.all,
            projectcss.h3,
            projectcss.__wab_text,
            sty.title2
          )}
        >
          <React.Fragment>{$props.title}</React.Fragment>
        </h3>
        <p
          data-plasmic-name={"desc"}
          data-plasmic-override={overrides.desc}
          className={classNames(
            projectcss.all,
            projectcss.p,
            projectcss.__wab_text,
            sty.desc
          )}
        >
          <React.Fragment>{$props.description}</React.Fragment>
        </p>
      </div>
      <div
        data-plasmic-name={"links"}
        data-plasmic-override={overrides.links}
        className={classNames(projectcss.all, sty.links)}
      >
        <PlasmicLink__
          data-plasmic-name={"download"}
          data-plasmic-override={overrides.download}
          aria-label={(() => {
            try {
              return `Download ${$props.title} excerpt`;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          className={classNames(
            projectcss.all,
            projectcss.a,
            projectcss.__wab_text,
            sty.download
          )}
          component={Link}
          href={(() => {
            try {
              return $props.downloadUrl;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "";
              }
              throw e;
            }
          })()}
          legacyBehavior={false}
          platform={"nextjs"}
          target={"_blank"}
          title={(() => {
            try {
              return `Download ${$props.title} excerpt`;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        >
          {"Download"}
        </PlasmicLink__>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  newsExcerptsItem: [
    "newsExcerptsItem",
    "top",
    "excerptDate",
    "title2",
    "desc",
    "links",
    "download"
  ],
  top: ["top", "excerptDate", "title2", "desc"],
  excerptDate: ["excerptDate"],
  title2: ["title2"],
  desc: ["desc"],
  links: ["links", "download"],
  download: ["download"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  newsExcerptsItem: "div";
  top: "div";
  excerptDate: "p";
  title2: "h3";
  desc: "p";
  links: "div";
  download: "a";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNewsItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNewsItem__VariantsArgs;
    args?: PlasmicNewsItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNewsItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNewsItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewsItem__ArgProps,
          internalVariantPropNames: PlasmicNewsItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewsItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "newsExcerptsItem") {
    func.displayName = "PlasmicNewsItem";
  } else {
    func.displayName = `PlasmicNewsItem.${nodeName}`;
  }
  return func;
}

export const PlasmicNewsItem = Object.assign(
  // Top-level PlasmicNewsItem renders the root element
  makeNodeComponent("newsExcerptsItem"),
  {
    // Helper components rendering sub-elements
    top: makeNodeComponent("top"),
    excerptDate: makeNodeComponent("excerptDate"),
    title2: makeNodeComponent("title2"),
    desc: makeNodeComponent("desc"),
    links: makeNodeComponent("links"),
    download: makeNodeComponent("download"),

    // Metadata about props expected for PlasmicNewsItem
    internalVariantProps: PlasmicNewsItem__VariantProps,
    internalArgProps: PlasmicNewsItem__ArgProps
  }
);

export default PlasmicNewsItem;
/* prettier-ignore-end */
